export const ALL = 'ALL'
export const UNPAID = 'UNPAID'
export const PAID = 'PAID'
export const UN_REVIEWED = 'PAID'  // 待评价的
export const REVIEWED = 'REVIEWED'
export const TIMEOUT = 'TIMEOUT'
export const CANCELED = 'CANCELED'



// WEBPACK FOOTER //
// ./src/store/orderState.js